/* eslint-disable react/display-name */
import * as React from 'react';

const Pinterest = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M30 6C16.7 6 6 16.7 6 30c0 10.2 6.3 18.9 15.3 22.3-.2-1.9-.4-4.8.1-6.9.4-1.9 2.8-11.9 2.8-11.9s-.7-1.4-.7-3.6c0-3.3 1.9-5.8 4.3-5.8 2 0 3 1.5 3 3.4 0 2.1-1.3 5.1-2 8-.6 2.4 1.2 4.3 3.6 4.3 4.3 0 7.5-4.5 7.5-11 0-5.7-4.1-9.8-10-9.8-6.8 0-10.8 5.1-10.8 10.4 0 2.1.8 4.3 1.8 5.5.2.2.2.4.2.7-.2.8-.6 2.4-.7 2.7-.1.4-.3.5-.8.3-3-1.4-4.9-5.8-4.9-9.3 0-7.6 5.5-14.5 15.9-14.5 8.3 0 14.8 5.9 14.8 13.9 0 8.3-5.2 14.9-12.5 14.9-2.4 0-4.7-1.3-5.5-2.8 0 0-1.2 4.6-1.5 5.7-.5 2.1-2 4.7-3 6.3 2.2.7 4.6 1.1 7.1 1.1 13.3 0 24-10.7 24-24C54 16.7 43.3 6 30 6" />
  </svg>
);

export default Pinterest;
